import api from "../../../services/api";

export interface EditEventPayload {
  title: string;
  description: string;
  source: string;
  start_at: string;
  end_at: string;
}

export interface EditEventResponse {
  id: string | number;
  title: string;
  description: string;
  source: string;
  start_at: string;
  end_at: string;
  updatedAt?: string;
}

export async function editEventService(
  keypointId: string | number,
  payload: EditEventPayload
): Promise<EditEventResponse> {
  const res = await api.patch<EditEventResponse>(`/api/key_points/${keypointId}`, payload);
  return res.data;
}